











import { Prop, Component } from 'vue-property-decorator';
import { IFormatParameter } from '@models';
import FormatParametersFormTypeBase from '../FormatParametersFormTypeBase/FormatParametersFormTypeBase';

@Component
export default class FormatParametersFormTextAreaType extends FormatParametersFormTypeBase {
  name = 'format-parameters-form-textarea-type';

  @Prop({
    type: Object as () => IFormatParameter,
    default: () => null
  })
  formatParameter: IFormatParameter;

  get str() {
    return this.local.value;
  }

  set str(str: string) {
    this.update(v => {
      v.file = null;
      v.value = str;
    });
  }

}
